import React from "react";
import { Button, Flex } from "@chakra-ui/react";

/**
 * PaginationControls Component
 * Reusable pagination with Previous/Next and page number buttons
 */
export default function PaginationControls({
  currentPage,
  totalPages,
  onPageChange,
}) {
  if (totalPages <= 1) return null;

  return (
    <Flex justify="center" align="center" gap={2} mt={6}>
      <Button
        size="sm"
        onClick={() => onPageChange(Math.max(1, currentPage - 1))}
        isDisabled={currentPage === 1}
      >
        Previous
      </Button>

      <Flex gap={1}>
        {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
          <Button
            key={page}
            size="sm"
            variant={currentPage === page ? "solid" : "outline"}
            colorScheme={currentPage === page ? "blue" : "gray"}
            onClick={() => onPageChange(page)}
          >
            {page}
          </Button>
        ))}
      </Flex>

      <Button
        size="sm"
        onClick={() => onPageChange(Math.min(totalPages, currentPage + 1))}
        isDisabled={currentPage === totalPages}
      >
        Next
      </Button>
    </Flex>
  );
}
